import { useEffect } from "react";
import { Props } from "./ExternalRedirect.Parts";

export const ExternalRedirect = ({ to }: Props) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);

  return null;
};
